'use strict';
const angular = require('angular');

const uiRouter = require('angular-ui-router');

import routes from './voting-show.routes';

export class VotingShowComponent {
  constructor($stateParams, VotingsService, $uibModal, $window, DTOptionsBuilder, User, SettingsService, PropertyService,
              $location, VoterGroupsService, HistoryService, ClosingSnapshotsService, $filter) {
    'ngInject';

    this.back = _ => $window.history.back();
    this.$filter = $filter;

    this.voteId = $stateParams.id;
    this.$uibModal = $uibModal;
    this.$location = $location;

    this.quorum = 0;
    this.attended = 0;
    this.totalVotings = 0;
    this.propertiesWithProxies = 0;
    this.propertiesQuorum = 0;

    this.VotingsService = VotingsService;
    this.PropertyService = PropertyService;
    this.VoterGroupsService = VoterGroupsService;
    this.HistoryService = HistoryService;
    this.ClosingSnapshotsService = ClosingSnapshotsService;

    SettingsService.getByName({name: 'client'}, settings => {
      this.proxyVoteAllowed = settings.data.proxy && settings.data.proxy.canVote;
      this.quorumThreshold = settings.data.quorum || 0;
      this.useSuite = settings.data.useSuite;

      this.weightVisible = settings.data.weightVisible;
      this.hasBuildingNo = settings.data.buildingNoVisible;

      this.dtOptionsBallots = DTOptionsBuilder
        .newOptions()
        .withOption('dom', 'lBfrtip')
        .withOption('ordering', false)
        .withOption('buttons', [
          {
            text: 'Voter Report',
            action: _ => {
              let ballots = this.vote.ballots.map(b => {
                return {id: b._id, name: b.name}
              });
              let ballotIds = ballots.map(b => b.id);
              let ballotNames = ballots.map(b => this.$filter('truncateText')(b.name, true, 45));

              let data = [];
              this.voters.forEach(property => {
                let votedBallots = [];

                ballotIds.forEach(id => {
                  if (this.isContactVoting) {
                    let voted = !!this.vote.votes.find(v => v.voter == property._id && v.ballot == id)
                    votedBallots.push(voted ? "Yes": "-");
                  } else {
                    let votedOnline = (property.eVoting && property.eVoting.voter)
                      ? !!this.vote.votes.find(v => v.voter == property.eVoting.voter._id && v.property == property._id && v.ballot == id && v.type == 'evote')
                      : false;

                    let votedPaper = !!this.vote.votes.find(v => v.property == property._id && v.ballot == id && v.type == 'paper' && !v.voteByProxy);
                    let votedProxy = !!this.vote.votes.find(v => v.property == property._id && v.ballot == id && v.type == 'paper' && v.voteByProxy);

                    let voted = "-";

                    if (votedOnline)
                      voted = "E-Vote"
                    else if (votedPaper)
                      voted = "Paper"
                    else if (votedProxy)
                      voted = "Proxy";

                    votedBallots.push(voted);
                  }
                });

                let address = (property.address && property.address.street) ? property.address.street : "";

                let fields = this.hasBuildingNo ? [property.buildingNo] : [];

                data.push(
                  this.isContactVoting
                    ? [this.getContactName(property), ...votedBallots]
                    : fields.concat([
                  property.lotNo,
                  address,
                  (property.eVoting && property.eVoting.voter) ? this.getContactName(property.eVoting.voter) : "-",
                  ...votedBallots
                ]));
              });

              let that = this;

              let headers = this.hasBuildingNo ? ["Bldg#"] : [];

              this.$uibModal.open({
                animation: true,
                component: 'datatableViewer',
                resolve: {
                  config: function () {
                    return {
                      data,
                      settings: {
                        "columns": that.isContactVoting
                          ? ["Voter", ...ballotNames]
                          : headers.concat(["Lot#", "Address", "Voter", ...ballotNames])
                      },
                      name: "Voter Report"
                    }
                  }
                },
                size: 'lg'
              });
            }
          }
        ]);

      this.dtOptionsAttendance = DTOptionsBuilder
        .newOptions()
//        .withOption('dom', 'lBfrtip')
        .withOption('order', (this.hasBuildingNo) ? [[0, 'asc'], [1, 'asc']] : [0, 'asc']);

      this.dtOptionsProxy = DTOptionsBuilder
        .newOptions()
        .withOption('dom', 'lBfrtip')
        .withOption('buttons', [
          {
            text: 'Export View',
            action: _ => {

              let data = [];
              this.voters.forEach(property => {

                let proxy = (property.proxy && property.proxy.enabled) ? "Yes" : "No";
                let type = "";
                let name = "";
                let approved = "";
                let address = (property.address && property.address.street) ? property.address.street : "";

                if (proxy == "Yes") {
                  type = (property.proxy.type == 'default') ? "Default Proxy" : "Write-in Proxy";
                  name = (property.proxy.type == 'default') ? this.vote.defaultProxy.name : property.proxy.writeInProxyName;

                  approved = "No";

                  if (property.proxy.type == 'default')
                    approved = "Yes";
                  else if (property.proxy.writeInProxyApproved)
                    approved = "Yes";
                }

                let fields = this.hasBuildingNo ? [property.buildingNo] : [];

                data.push(fields.concat([
                  property.lotNo,
                  address,
                  this.getContactName(property.eVoting.voter),
                  proxy,
                  type,
                  name,
                  approved
                ]));
              });

              let headers = this.hasBuildingNo ? ["Bldg#"] : [];

              this.$uibModal.open({
                animation: true,
                component: 'datatableViewer',
                resolve: {
                  config: function () {
                    return {
                      data,
                      settings: {
                        "columns": headers.concat([
                          "Lot#",
                          "Address",
                          "Voter",
                          "Proxy",
                          "Type",
                          "Proxy Holder",
                          "Approved"
                        ])
                      },
                      name: "Proxy List"
                    }
                  }
                },
                size: 'lg'
              });
            }
          }
        ])
        .withOption('order', (this.hasBuildingNo) ? [[0, 'asc'], [1, 'asc']] : [0, 'asc']);

      this.refreshData();
    });

    this.dtOptionsUpcoming = DTOptionsBuilder
      .newOptions()
      .withOption('rowGroup', [0])
      .withOption('columnDefs', [ {
        targets: [0],
        visible: false
      } ]);

    this.dtOptionsHistory = DTOptionsBuilder
      .newOptions()
      .withOption('order', [[0, 'desc']]);

    this.chartOptionsStartFromZero = {
      scales: {
        xAxes: [{
          ticks: {
            beginAtZero: true
          }
        }],
        yAxes: [{
          ticks: {
            beginAtZero: true
          }
        }]
      }
    };

  }

  getPrimaryOwnerId(contacts) {
    if (!contacts) return 0;

    let primary = contacts.find(contact => contact.type == 'primary-owner');

    if (!primary) // No Primary Owner
      return 0;
    else if (!primary.contact || !primary.contact._id) // Contact for Primary Owner deleted
      return -1;
    else
      return primary.contact._id;
  }

  getOtherOwnerId(contacts) {
    if (!contacts) return 0;

    let other = contacts.find(contact => contact.type == 'owner');

    if (!other) // No Other Owner
      return 0;
    else if (!other.contact || !other.contact._id) // Contact for Other Owner deleted
      return -1;
    else
      return other.contact._id;
  }

  getComposedName(contact) {
    let composedName = "";

    if (contact.lastName) {
      composedName = contact.lastName + ", " + contact.firstName;
      if (contact.middleName)
        composedName += " " + contact.middleName;
    }

    if (contact.company) {
      if (composedName == "") {
        composedName += contact.company;
      } else {
        composedName += "<br/>" + contact.company;
      }
    }

    return composedName;
  }

  getVotesPerBallot(ballotId, voting) {
    return [... new Set(voting.votes.filter(v => v.ballot == ballotId).map(v => this.isContactVoting ? v.contact : v.property))].length;
  }

  getPrimaryOwner(contacts) {
    if (!contacts || !contacts.length)
      return "-";

    let primary = contacts.find(contact => contact.type == 'primary-owner');

    if (!primary)
      return "-";

    return this.getComposedName(primary.contact);
  }

  getOtherOwner(contacts) {
    if (!contacts || !contacts.length)
      return "-";

    let other = contacts.find(contact => contact.type == 'owner');

    if (!other)
      return "-";

    return this.getComposedName(other.contact);
  }

  getContactName(contact) {
    if (!contact || (!contact.lastName && !contact.company))
      return "-";

    return this.getComposedName(contact);
  }

  updateProxy(voter, property, proxy) {
    this.VotingsService.updateProxy({id: this.vote._id, propertyId: property}, proxy);
  }

  updateAttendance(voter, property, attendance) {
    this.VotingsService.updateAttendance({id: this.vote._id, propertyId: property}, {value: attendance});
  }

  showResults(ballot, secret) {
    this.$location.url(`/voting/${this.vote._id}/ballot/result/${ballot._id}`);
  }

  openAssetUploadModal() {
    var that = this;

    var modalInstance = this.$uibModal.open({
      animation: true,
      component: 'assetUpload',
      resolve: {
        config: function() {
          return {}
        }
      }
    });

    modalInstance.result.then(resultIds => {
        that.VotingsService.addAttachments({id: that.voteId}, resultIds, _ => {
          that.refreshData();
        }, err => {
          console.log('could not add attachments to contact');
        });
      },
      function () { /* cancel */ }
    );

  }

  refreshData() {
    this.quorum = 0;
    this.attended = 0;
    this.totalVotings = 0;
    this.propertiesWithProxies = 0;
    this.hasQuorum = 0;

    this.proxyTypes = [{
      name: "Write-in Proxy",
      type: "write-in"
    }];

    this.historyInit = false;
    this.dataInitComplete = false;

    if (this.voteId) {
      this.VotingsService.get({id: this.voteId}, data => {
        this.vote = data;

        this.maxHistory = this.vote.ballots.length + 1;
        this.currentHistory = 0;

        this.HistoryService.getByEntity({id: this.voteId}, data => {

          this.history = data.map(entry => {
            entry.context = this.vote.name;
            return entry;
          });

          this.currentHistory++;
          if (this.currentHistory == this.maxHistory) // in the strange case that there are no ballots, show at least the voting event history
            this.historyInit = true;

          this.vote.ballots.forEach(ballot => {
            this.HistoryService.getByEntity({id: ballot._id}, data => {
              this.history = this.history.concat(data.map(entry => {
                entry.context = ballot.name;
                return entry;
              }));

              this.currentHistory++;
              if (this.currentHistory == this.maxHistory)
                this.historyInit = true;
            });
          });
        });

        let processData = voterData => {
          this.voters = voterData;

          if (this.vote.defaultProxy && this.vote.defaultProxy.enabled && this.vote.defaultProxy.name) {
            this.proxyTypes.unshift({
              name: "Default Proxy",
              type: "default"
            });
          }

          let quorumMap = {};
          let quorumIds = this.voters.map(v => v._id);

          quorumIds.forEach(id => quorumMap[id] = 0);

          if (!this.isContactVoting) {

            this.vote.attendances.forEach(att => {
              let voter = this.voters
                .filter(u => u.eVoting && u.eVoting.voter && u.eVoting.voter._id)
                .find(u => u._id == att.property);
              //.find(u => u.eVoting.voter._id == att.voter && u._id == att.property);

              if (voter)
                voter.attended = att.attended;

              if (voter && voter.attended && quorumMap.hasOwnProperty(att.property)) {
                this.attended++;
                quorumMap[att.property]++;
              }
            });

            this.vote.proxies.forEach(prox => {
              let voter = this.voters
                .filter(u => u.eVoting && u.eVoting.voter && u.eVoting.voter._id)
                .find(u => u._id == prox.property);
              //.find(u => u.eVoting.voter._id == prox.voter && u._id == prox.property);

              if (voter) {
                voter.proxy = prox.proxy;

                if (!voter.proxy.enabled) return;

                if (quorumMap.hasOwnProperty(prox.property)) {
                  if (prox.proxy.type == 'default' || (prox.proxy.type == 'write-in' && prox.proxy.writeInProxyName && prox.proxy.writeInProxyApproved)) {
                    this.propertiesWithProxies++;
                    quorumMap[prox.property]++;
                  }
                }
              }

            });

            this.vote.votes.forEach(vote => {
              if (quorumMap.hasOwnProperty(vote.property)) {
                this.totalVotings++;
                quorumMap[vote.property]++;
              }
            });
          } else { // contact voting
            this.vote.votes.forEach(vote => {
              if (quorumMap.hasOwnProperty(vote.voter)) {
                this.totalVotings++;
                quorumMap[vote.voter]++;
              }
            });
          }

          Object.keys(quorumMap).forEach(id => {
            if (quorumMap[id]) {
              this.hasQuorum++;
            }
          });

          this.quorum = this.hasQuorum / this.voters.length;
          this.dataInitComplete = true;
        };

        if (this.vote.state == 'closed' && this.vote.closingSnapshot) {
          this.ClosingSnapshotsService.get({id: this.vote.closingSnapshot}, snapshot => {
            this.snapshotDate = snapshot.meta.clientDate || snapshot.meta.creationDate;
            this.snapshot = snapshot;

            this.isContactVoting = this.snapshot && this.snapshot.type == 'contacts';
            processData(snapshot.data);
          });
        } else {
          let VG_QUERY_METHOD = (this.useSuite) ? "getWithDataSuite" : "getWithData";
          this.VoterGroupsService[VG_QUERY_METHOD]({id: this.vote.voterGroup._id}, vg => {
            this.isContactVoting = this.vote.voterGroup && this.vote.voterGroup.type == 'contacts';
            let data = (this.isContactVoting) ? vg.contacts : vg.properties;
            processData(data);
          });
        }

      }, err => {
        console.log('Could not load vote from server');
      });
    }
  }

}

export default angular.module('conduu.votingShow', [uiRouter])
  .config(routes)
  .component('votingShow', {
    template: require('./voting-show.html'),
    controller: VotingShowComponent,
    controllerAs: 'ctrl'
  })
  .name;



// WEBPACK FOOTER //
// ./client/app/voting/voting-show/voting-show.component.js